import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";

export default class CmsBlockQRScanner extends CmsBlock {
    static typeDef = {
        name: `AR Scanner|Scanner AR`,
        glyph: `fa-qrcode-read`,
        type: `qr-scanner`,
        category: `widget`
    }

    constructor(data, page) {
        super(data, page);

        if (!data) {
            // nothing yet
        }
    }
}
